export const CODE_SCANNER = {
  TITLE: 'Code Scanner',
  CONFIGURATION: {
    TITLE: 'Configuration',
    DESCRIPTION:
      'Download your public SSH key to configure this capability. ' +
      "This key will be used to scan your organization's code repositories.",
    URLS: {
      SETUP: 'Download public SSH key',
    },
  },
  REPORTS: {
    TITLE: 'Reports',
    DESCRIPTION:
      'You will have access here to an executive summary of the scan results ' +
      "describing your organization's code security posture, " +
      'plus a report with the details for those critical findings.',
    DOWNLOAD: {
      Last: 'Download Last Report',
    },
  },
  DOCUMENTATION: {
    TITLE: 'Documentation',
    DESCRIPTION:
      'Access the documentation to learn how to setup our code scanner capability, ' +
      'as well as understand the reports generated.',
    URLS: {
      GUIDE_BITBUCKET: 'Qalea Code Scanner Setup Guide for Bitbucket',
      GUIDE_GITHUB: 'Qalea Code Scanner Setup Guide for GitHub',
      GUIDE_GITLAB: 'Qalea Code Scanner Setup Guide for GitLab',
    },
  },
  INSIGHTS: {
    TITLE: 'Insights',
    DESCRIPTION:
      'Gain valuable insights from your code scans. Review results and discover recommended actions ' +
      "to strengthen your organization's security by focusing on code scanning.",
    TRENDS_NOT_YET_AVAILABLE: 'Code scans not started yet',
  },
}
